import { render, staticRenderFns } from "./ReservationsCalendar.vue?vue&type=template&id=78406006&"
import script from "./ReservationsCalendar.vue?vue&type=script&lang=js&"
export * from "./ReservationsCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports